/**
 * Action Types Constants
 * https://redux.js.org/basics/actions
 */

const AuthConstants = {
  AUTH_CALLBACK_ERROR: 'AUTH_CALLBACK_ERROR',
  AUTH_CALLBACK_SUCCESS: 'AUTH_CALLBACK_SUCCESS',
}

export default AuthConstants;
